import {
    all,
    fork,
    takeEvery,
    call,
    put,
} from 'redux-saga/effects';
import { extractError } from '@iso/lib//helpers/api';
import { types, actions } from './reducer';
import SeasonService from '@iso/services/SettingsService/ProductService/SeasonService';

function* deleteSeason({ id }) {
    try {
        yield call(SeasonService.deleteOne, id);
        yield put(actions.deleteSeasonSucceeded(id));
    } catch (error) {
        yield put(actions.deleteSeasonFailed(extractError(error)));
    }
}

function* watchDeleteSeason() {
    yield takeEvery(
        types.REQUEST_DELETE_SEASON,
        deleteSeason,
    );
}

function* deleteSaga() {
    yield all([
        fork(watchDeleteSeason),
    ]);
}

export default deleteSaga;
